import { render, staticRenderFns } from "./PolicyInquiry.vue?vue&type=template&id=36526df6"
import script from "./PolicyInquiry.vue?vue&type=script&lang=ts"
export * from "./PolicyInquiry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports